export default __webpack_public_path__ + "static/media/no-promotions-img.ecbeff55.svg";